import { observer } from 'mobx-react-lite';
import { IMAGES } from '../../../game/data/images';
import { Popup } from '../Reusable/Popup';
import { MinimPopup } from './Popups';
import { DATA } from '../../../game/data';

export const TutorialPopups = observer(() => {
  return (
    <>
      {DATA.tutorialStep === 'step1' && (
        <MinimPopup>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'center', justifyContent: 'center' }}>
            <img src={IMAGES.SHAPES.circle_big} style={{ width: 28 }} />
            <div>Click on an aiport with an airplane</div>
          </div>
        </MinimPopup>
      )}
      {DATA.tutorialStep === 'step3' && (
        <MinimPopup>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'center', justifyContent: 'center' }}>
            <img src={IMAGES.AIRPLANES.blue} style={{ width: 28 }} />
            <div>You can also click on idle airplanes to quickly fly to the most profitable destination.</div>
          </div>
        </MinimPopup>
      )}
    </>
  );
});
